import { SyllabaryHiraganaIcon } from './SyllabaryHiraganaIcon';

/**
 * author: Haley Halcyon
 * id 8B8AF349-F9B5-483B-90CC-387F3791AF69
 * name syllabary-hiragana
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/syllabary-hiragana.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemHiraganaIcon = SyllabaryHiraganaIcon;
export default WritingSystemHiraganaIcon